"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1236],{

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://psyop.rest/_next/image?url=logo.png&w=256&q=75" , title ="STZY Marketplace" , description ="STZY MarketPlace"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@stzygangshop"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "STZY NFT Explorer Banner"
            })
        ]
    });
};


/***/ }),

/***/ 61955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40299);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var utils_chains__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43810);
/* harmony import */ var components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79320);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35430);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);










const ChainToggle = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const { chain , switchCurrentChain  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ChainContext */ .p);
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s4)();
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_7__/* .useTheme */ .F)();
    if (!isMounted || utils_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"].length */ .ZP.length === 1) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .ToggleGroup */ .tX, {
        type: "single",
        value: chain.name,
        children: utils_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"].map */ .ZP.map((chainOption)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_9__/* .Root */ .fC, {
                delayDuration: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_9__/* .Trigger */ .xz, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .ToggleGroupItem */ .GX, {
                            asChild: true,
                            value: chainOption.name,
                            disabled: chainOption.name === chain.name,
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, chainOption.routePrefix);
                                switchCurrentChain(chainOption.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                css: {
                                    width: 56,
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: theme === "dark" ? chainOption.darkIconUrl : chainOption.lightIconUrl,
                                    style: {
                                        height: 20
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_9__/* .Content */ .VY, {
                        sideOffset: -4,
                        side: "top",
                        align: "center",
                        style: {
                            zIndex: 100,
                            filter: "drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.3))"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* .TooltipArrow */ .C, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                css: {
                                    zIndex: 9999,
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
                                    borderRadius: 8,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                    css: {
                                        background: "$neutralBgSubtle",
                                        p: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                        style: "body3",
                                        as: "p",
                                        children: chainOption === null || chainOption === void 0 ? void 0 : chainOption.name
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, chainOption.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChainToggle);


/***/ }),

/***/ 39968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92902);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12623);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34509);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59417);






const sortingOptions = [
    "1DayVolume",
    "7DayVolume",
    "30DayVolume",
    "allTimeVolume"
];
const nameForSortingOption = (option, compact)=>{
    switch(option){
        case "1DayVolume":
            return compact ? "24h" : "24 hours";
        case "7DayVolume":
            return compact ? "7d" : "7 days";
        case "30DayVolume":
            return compact ? "30d" : "30 days";
        case "allTimeVolume":
            return compact ? "All" : "All Time";
    }
};
const CollectionsTimeDropdown = (param)=>{
    let { compact =false , option , onOptionSelected  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .Root */ .fC, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .Trigger */ .xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                    color: "gray3",
                    css: {
                        px: "14px",
                        justifyContent: "space-between",
                        "@md": {
                            width: "220px",
                            minWidth: "max-content",
                            px: "$4"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            style: "body1",
                            children: nameForSortingOption(option, compact)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                color: "$gray10",
                                transition: "transform",
                                "[data-state=open] &": {
                                    transform: "rotate(180deg)"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faChevronDown */ .ptq,
                                width: 16
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenuContent */ .AW, {
                css: {
                    width: "220px",
                    mt: "$2",
                    zIndex: 1000
                },
                children: sortingOptions.map((optionItem)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenuItem */ .Xi, {
                        css: {
                            py: "$3"
                        },
                        onClick: ()=>onOptionSelected(optionItem),
                        children: nameForSortingOption(optionItem, false)
                    }, optionItem))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionsTimeDropdown);


/***/ }),

/***/ 12623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ DropdownMenuContent; },
/* harmony export */   "Lt": function() { return /* binding */ Dropdown; },
/* harmony export */   "Xi": function() { return /* binding */ DropdownMenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34509);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12664);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21190);





const DropdownMenuContent = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuContent */ .AW, {
    mx: "$4",
    p: "$2",
    borderRadius: 8,
    zIndex: 5,
    background: "$dropdownBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const AnimatedDropdownMenuContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownMenuContent, {
        asChild: true,
        forceMount: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            initial: {
                scale: 0.9,
                opacity: 0,
                y: -20
            },
            animate: {
                scale: 1,
                opacity: 1,
                y: 0,
                transition: {
                    mass: 0.05,
                    type: "spring",
                    duration: 0.1
                }
            },
            exit: {
                y: -20,
                scale: 0.9,
                opacity: 0,
                transition: {
                    duration: 0.1
                }
            },
            children: children
        })
    });
});
const DropdownMenuItem = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .DropdownMenuItem */ .Xi, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$2",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "$gray5"
    },
    "&:focus": {
        backgroundColor: "$gray5"
    }
});
const Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>{
    let { children , trigger , contentProps , ...props } = param;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
        ...props,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
                children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimatedDropdownMenuContent, {
                    ref: forwardedRef,
                    ...contentProps,
                    children: children
                })
            })
        ]
    });
});



/***/ }),

/***/ 31561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ PercentChange; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./utils/round.ts
const round = function(num) {
    let percision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
    return Math.floor(num * Math.pow(10, percision)) / Math.pow(10, percision);
};
/* harmony default export */ var utils_round = (round);

// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
;// CONCATENATED MODULE: ./components/primitives/PercentChange.tsx



const PercentChange = (param)=>{
    let { value , decimals =2 , ...props } = param;
    if (value === undefined || value === null || value === 0) return null;
    const percentage = (value - 1) * 100;
    const isPositive = percentage > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
        style: props.style || "subtitle3",
        css: {
            color: isPositive ? "$green11" : "$red11",
            ml: "$1"
        },
        ...props,
        children: [
            utils_round(percentage, decimals),
            "%"
        ]
    });
};


/***/ }),

/***/ 71567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CollectionRankingsTable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var components_common_OpenSeaVerified__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44930);
/* harmony import */ var components_navbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13282);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92902);
/* harmony import */ var components_primitives_Img__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68916);
/* harmony import */ var components_primitives_PercentChange__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31561);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35430);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var utils_optimizeImage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77497);













const desktopTemplateColumns = "1.5fr 1.7fr repeat(3, 0.6fr)";
const CollectionRankingsTable = (param)=>{
    let { collections , loading , volumeKey  } = param;
    const isSmallDevice = (0,react_responsive__WEBPACK_IMPORTED_MODULE_10__.useMediaQuery)({
        maxWidth: 900
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !loading && collections.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
            direction: "column",
            align: "center",
            css: {
                py: "$6",
                gap: "$4",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    css: {
                        color: "$gray11"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faMagnifyingGlass */ .Y$T,
                        size: "2xl"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    css: {
                        color: "$gray11"
                    },
                    children: "No collections found"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
            direction: "column",
            css: {
                width: "100%",
                pb: "$2"
            },
            children: [
                isSmallDevice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                    justify: "between",
                    css: {
                        mb: "$4",
                        "@md": {
                            display: "none"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            children: "Collection"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            children: "Volume"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableHeading, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                    direction: "column",
                    css: {
                        position: "relative"
                    },
                    children: collections.map((collection, i)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RankingsTableRow, {
                            collection: collection,
                            rank: i + 1,
                            volumeKey: volumeKey
                        }, collection.id);
                    })
                })
            ]
        })
    });
};
const RankingsTableRow = (param)=>{
    let { collection , rank , volumeKey  } = param;
    const { routePrefix  } = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* .useMarketplaceChain */ .gw)();
    const isSmallDevice = (0,react_responsive__WEBPACK_IMPORTED_MODULE_10__.useMediaQuery)({
        maxWidth: 900
    });
    const collectionImage = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(()=>{
        return (0,utils_optimizeImage__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(collection.image, 250);
    }, [
        collection.image
    ]);
    if (isSmallDevice) {
        var _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_currency, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_currency1, _collection_volume, _collection_volumeChange;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
            href: "/".concat(routePrefix, "/collection/").concat(collection.id),
            style: {
                display: "inline-block",
                minWidth: 0,
                marginBottom: 24
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                align: "center",
                css: {
                    cursor: "pointer"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        css: {
                            mr: "$4",
                            width: 15
                        },
                        style: "subtitle3",
                        children: rank
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        src: collectionImage,
                        css: {
                            borderRadius: 8,
                            width: 48,
                            height: 48,
                            objectFit: "cover"
                        },
                        alt: "Collection Image",
                        width: 48,
                        height: 48,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                        css: {
                            ml: "$4",
                            width: "100%",
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                align: "center",
                                css: {
                                    gap: "$2",
                                    mb: 4,
                                    maxWidth: "80%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        css: {
                                            display: "inline-block"
                                        },
                                        style: "subtitle1",
                                        ellipsify: true,
                                        children: collection === null || collection === void 0 ? void 0 : collection.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_OpenSeaVerified__WEBPACK_IMPORTED_MODULE_2__/* .OpenSeaVerified */ .v, {
                                        openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        css: {
                                            mr: "$1",
                                            color: "$gray11"
                                        },
                                        style: "body3",
                                        children: "Floor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                        amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.decimal,
                                        address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price1.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.contract,
                                        decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk2 = collection.floorAsk) === null || _collection_floorAsk2 === void 0 ? void 0 : (_collection_floorAsk_price2 = _collection_floorAsk2.price) === null || _collection_floorAsk_price2 === void 0 ? void 0 : (_collection_floorAsk_price_currency1 = _collection_floorAsk_price2.currency) === null || _collection_floorAsk_price_currency1 === void 0 ? void 0 : _collection_floorAsk_price_currency1.decimals,
                                        logoHeight: 16,
                                        maximumFractionDigits: 2,
                                        textStyle: "subtitle2"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        direction: "column",
                        align: "end",
                        css: {
                            gap: "$1"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                amount: collection === null || collection === void 0 ? void 0 : (_collection_volume = collection.volume) === null || _collection_volume === void 0 ? void 0 : _collection_volume[volumeKey],
                                maximumFractionDigits: 1,
                                logoHeight: 16,
                                textStyle: "subtitle1"
                            }),
                            volumeKey !== "allTime" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_PercentChange__WEBPACK_IMPORTED_MODULE_6__/* .PercentChange */ .q, {
                                value: collection === null || collection === void 0 ? void 0 : (_collection_volumeChange = collection.volumeChange) === null || _collection_volumeChange === void 0 ? void 0 : _collection_volumeChange[volumeKey],
                                decimals: 1
                            })
                        ]
                    })
                ]
            })
        }, collection.id);
    } else {
        var _collection_sampleImages, _collection_volume1, _collection_floorAsk3, _collection_floorAsk_price3, _collection_floorAsk_price_amount1, _collection_floorAsk4, _collection_floorAsk_price4, _collection_floorAsk_price_currency2, _collection_floorAsk5, _collection_floorAsk_price5, _collection_floorAsk_price_currency3, _collection_topBid, _collection_topBid_price, _collection_topBid_price_amount, _collection_topBid1, _collection_topBid_price1, _collection_topBid_price_currency;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableRow */ .SC, {
            css: {
                gridTemplateColumns: desktopTemplateColumns
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                    css: {
                        minWidth: 0
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                        href: "/".concat(routePrefix, "/collection/").concat(collection.id),
                        style: {
                            display: "inline-block",
                            width: "100%",
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                            align: "center",
                            css: {
                                gap: "$2",
                                cursor: "pointer",
                                minWidth: 0,
                                overflow: "hidden",
                                width: "100$"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                    css: {
                                        mr: "$2",
                                        width: 15
                                    },
                                    style: "subtitle3",
                                    children: rank
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: collectionImage,
                                    css: {
                                        borderRadius: 8,
                                        width: 56,
                                        height: 56,
                                        objectFit: "cover"
                                    },
                                    alt: "Collection Image",
                                    width: 56,
                                    height: 56,
                                    unoptimized: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                    css: {
                                        display: "inline-block",
                                        minWidth: 0
                                    },
                                    style: "subtitle1",
                                    ellipsify: true,
                                    children: collection === null || collection === void 0 ? void 0 : collection.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_OpenSeaVerified__WEBPACK_IMPORTED_MODULE_2__/* .OpenSeaVerified */ .v, {
                                    openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        css: {
                            gap: "$3",
                            minWidth: 0
                        },
                        children: collection === null || collection === void 0 ? void 0 : (_collection_sampleImages = collection.sampleImages) === null || _collection_sampleImages === void 0 ? void 0 : _collection_sampleImages.map((image, i)=>{
                            if (image) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,utils_optimizeImage__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(image, 250),
                                    style: {
                                        borderRadius: 8,
                                        width: 56,
                                        height: 56,
                                        objectFit: "cover"
                                    },
                                    onError: (e)=>{
                                        e.currentTarget.style.visibility = "hidden";
                                    }
                                }, image + i);
                            }
                            return null;
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        direction: "column",
                        align: "start",
                        justify: "start",
                        css: {
                            height: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                amount: collection === null || collection === void 0 ? void 0 : (_collection_volume1 = collection.volume) === null || _collection_volume1 === void 0 ? void 0 : _collection_volume1[volumeKey],
                                textStyle: "subtitle2",
                                logoHeight: 14
                            }),
                            volumeKey != "allTime" && (collection === null || collection === void 0 ? void 0 : collection.volumeChange) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_PercentChange__WEBPACK_IMPORTED_MODULE_6__/* .PercentChange */ .q, {
                                value: collection === null || collection === void 0 ? void 0 : collection.volumeChange[volumeKey]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        direction: "column",
                        align: "start",
                        justify: "start",
                        css: {
                            height: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk3 = collection.floorAsk) === null || _collection_floorAsk3 === void 0 ? void 0 : (_collection_floorAsk_price3 = _collection_floorAsk3.price) === null || _collection_floorAsk_price3 === void 0 ? void 0 : (_collection_floorAsk_price_amount1 = _collection_floorAsk_price3.amount) === null || _collection_floorAsk_price_amount1 === void 0 ? void 0 : _collection_floorAsk_price_amount1.decimal,
                                address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk4 = collection.floorAsk) === null || _collection_floorAsk4 === void 0 ? void 0 : (_collection_floorAsk_price4 = _collection_floorAsk4.price) === null || _collection_floorAsk_price4 === void 0 ? void 0 : (_collection_floorAsk_price_currency2 = _collection_floorAsk_price4.currency) === null || _collection_floorAsk_price_currency2 === void 0 ? void 0 : _collection_floorAsk_price_currency2.contract,
                                decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk5 = collection.floorAsk) === null || _collection_floorAsk5 === void 0 ? void 0 : (_collection_floorAsk_price5 = _collection_floorAsk5.price) === null || _collection_floorAsk_price5 === void 0 ? void 0 : (_collection_floorAsk_price_currency3 = _collection_floorAsk_price5.currency) === null || _collection_floorAsk_price_currency3 === void 0 ? void 0 : _collection_floorAsk_price_currency3.decimals,
                                textStyle: "subtitle2",
                                logoHeight: 14
                            }),
                            volumeKey != "allTime" && (collection === null || collection === void 0 ? void 0 : collection.floorSaleChange) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_PercentChange__WEBPACK_IMPORTED_MODULE_6__/* .PercentChange */ .q, {
                                value: collection === null || collection === void 0 ? void 0 : collection.floorSaleChange[volumeKey]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                        amount: collection === null || collection === void 0 ? void 0 : (_collection_topBid = collection.topBid) === null || _collection_topBid === void 0 ? void 0 : (_collection_topBid_price = _collection_topBid.price) === null || _collection_topBid_price === void 0 ? void 0 : (_collection_topBid_price_amount = _collection_topBid_price.amount) === null || _collection_topBid_price_amount === void 0 ? void 0 : _collection_topBid_price_amount.decimal,
                        textStyle: "subtitle2",
                        logoHeight: 14,
                        address: collection === null || collection === void 0 ? void 0 : (_collection_topBid1 = collection.topBid) === null || _collection_topBid1 === void 0 ? void 0 : (_collection_topBid_price1 = _collection_topBid1.price) === null || _collection_topBid_price1 === void 0 ? void 0 : (_collection_topBid_price_currency = _collection_topBid_price1.currency) === null || _collection_topBid_price_currency === void 0 ? void 0 : _collection_topBid_price_currency.contract
                    })
                })
            ]
        }, collection.id);
    }
};
const headings = [
    "Collection",
    "",
    "Volume",
    "Floor Price",
    "Top Offer"
];
const TableHeading = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .HeaderRow */ .VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: desktopTemplateColumns,
            position: "sticky",
            top: components_navbar__WEBPACK_IMPORTED_MODULE_3__/* .NAVBAR_HEIGHT */ .ik,
            backgroundColor: "$neutralBg",
            zIndex: 1
        },
        children: headings.map((heading)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .TableCell */ .pj, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });


/***/ })

}]);